import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import { Link } from "react-router-dom";
import React from "react";
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from './components/LanguageSwitcher';

function PrivacyInfo() {
  const { t, i18n } = useTranslation(['privacy', 'common']);

  // Check if current language is RTL (Arabic)
  const isRTL = i18n.language === 'ar';

  return (
    <div className={`container my-5 ${isRTL ? 'rtl' : ''}`} dir={isRTL ? 'rtl' : 'ltr'}>
      <div className="language-switcher-container position-fixed top-0 end-0 m-3" style={{ zIndex: 1000 }}>
        <LanguageSwitcher />
      </div>

      <div className="row">
        <div className="col-lg-10 offset-lg-1">
          <Link to="/" className="btn btn-link mb-3">
            {t('common:navigation.backToHome')}
          </Link>

          <h1 className="mb-4">{t('privacy:title')}</h1>

          {/* Introduction */}
          <div className="card mb-4">
            <div className="card-body">
              <h2 className="h4 card-title">{t('privacy:intro.title')}</h2>
              <p className="card-text">{t('privacy:intro.text1')}</p>
              <p className="card-text">{t('privacy:intro.text2')}</p>
              <p className="card-text">{t('privacy:intro.text3')}</p>
            </div>
          </div>

          {/* For Regular Users */}
          <div className="card mb-4">
            <div className="card-body">
              <h2 className="h4 card-title">{t('privacy:forUsers.title')}</h2>

              <h3 className="h5 mt-3">{t('privacy:forUsers.whatIsEncrypted.title')}</h3>
              <ul>
                <li>{t('privacy:forUsers.whatIsEncrypted.item1')}</li>
                <li>{t('privacy:forUsers.whatIsEncrypted.item2')}</li>
                <li>{t('privacy:forUsers.whatIsEncrypted.item3')}</li>
              </ul>

              <h3 className="h5 mt-3">{t('privacy:forUsers.howItWorks.title')}</h3>
              <p>{t('privacy:forUsers.howItWorks.text1')}</p>
              <p>{t('privacy:forUsers.howItWorks.text2')}</p>
              <p>{t('privacy:forUsers.howItWorks.text3')}</p>

              <h3 className="h5 mt-3">{t('privacy:forUsers.sharing.title')}</h3>
              <p>{t('privacy:forUsers.sharing.text1')}</p>
              <p>{t('privacy:forUsers.sharing.text2')}</p>
              <div className="alert alert-warning">
                <strong>{t('privacy:forUsers.sharing.warningTitle')}</strong>{' '}
                {t('privacy:forUsers.sharing.warningText')}
              </div>
            </div>
          </div>

          {/* Additional Details */}
          <div className="card mb-4">
            <div className="card-body">
              <h2 className="h4 card-title">{t('privacy:details.title')}</h2>

              <h3 className="h5 mt-3">{t('privacy:details.urlFragment.title')}</h3>
              <p>{t('privacy:details.urlFragment.text1')}</p>
              <p>{t('privacy:details.urlFragment.text2')}</p>

              <h3 className="h5 mt-3">{t('privacy:details.adminLinks.title')}</h3>
              <p>{t('privacy:details.adminLinks.text1')}</p>
              <p>{t('privacy:details.adminLinks.text2')}</p>

              <h3 className="h5 mt-3">{t('privacy:details.anonymous.title')}</h3>
              <p>{t('privacy:details.anonymous.text')}</p>
            </div>
          </div>

          {/* Technical Details */}
          <div className="card mb-4">
            <div className="card-body">
              <h2 className="h4 card-title">{t('privacy:technical.title')}</h2>

              <h3 className="h5 mt-3">{t('privacy:technical.encryption.title')}</h3>
              <ul>
                <li><strong>{t('privacy:technical.encryption.algorithm')}:</strong> AES-GCM (Advanced Encryption Standard - Galois/Counter Mode)</li>
                <li><strong>{t('privacy:technical.encryption.keySize')}:</strong> 128 {t('privacy:technical.encryption.bits')}</li>
                <li><strong>{t('privacy:technical.encryption.ivSize')}:</strong> 96 {t('privacy:technical.encryption.bits')}</li>
                <li><strong>{t('privacy:technical.encryption.tagSize')}:</strong> 96 {t('privacy:technical.encryption.bits')}</li>
              </ul>

              <h3 className="h5 mt-3">{t('privacy:technical.implementation.title')}</h3>
              <p>{t('privacy:technical.implementation.text1')}</p>
              <p>{t('privacy:technical.implementation.text2')}</p>
              <p>{t('privacy:technical.implementation.text3')}</p>

              <h3 className="h5 mt-3">{t('privacy:technical.ivUsage.title')}</h3>
              <p>{t('privacy:technical.ivUsage.text1')}</p>
              <p>{t('privacy:technical.ivUsage.text2')}</p>

              <h3 className="h5 mt-3">{t('privacy:technical.storage.title')}</h3>
              <p>{t('privacy:technical.storage.text1')}</p>
              <p>{t('privacy:technical.storage.text2')}</p>
            </div>
          </div>

          {/* Security Considerations */}
          <div className="card mb-4">
            <div className="card-body">
              <h2 className="h4 card-title">{t('privacy:security.title')}</h2>
              <ul>
                <li>{t('privacy:security.item1')}</li>
                <li>{t('privacy:security.item2')}</li>
                <li>{t('privacy:security.item3')}</li>
                <li>{t('privacy:security.item4')}</li>
                <li>{t('privacy:security.item5')}</li>
              </ul>
            </div>
          </div>

          <div className="text-center mt-5 mb-4">
            <Link to="/" className="btn btn-primary">
              {t('common:navigation.backToHome')}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PrivacyInfo;
